module.exports = __webpack_public_path__ + "static/media/studentlife-kline--resized.769b8522.jpg";